module.exports = __webpack_public_path__ + "assets/img/94c2877af8f70087b33e87984a6daf2c.png";